import { ReactNode } from 'react';

interface FeaturesLineProps {
  readonly children: ReactNode;
}

export function FeaturesLine({ children }: FeaturesLineProps) {
  return <div className="features_line flex flex-col sm:flex-row gap-6 w-full sm:w-[75%]">{children}</div>;
}
